export const initialState = {
  cart: null,
  total: 0,
}

export const actionType = {
  SET_CART: "SET_CART",
  SET_TOTAL: "SET_TOTAl"
}

const reducer = (state, action) => {
  console.log(action);

  switch (action.type) {
    case actionType.SET_CART:
      return {
        ...state,
        cart: action.cart
      }
      case actionType.SET_TOTAL:
        return {
          ...state,
          total: action.total
        }
  
    default:
      return state
  }
}

export default reducer